var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var PEPHealthService = /** @class */ (function () {
    function PEPHealthService(client) {
        var _this = this;
        this.client = client;
        // private extractPageNumber = (url: string): number => {
        //   const pageNumberMatch = url.match(/page=([0-9]+)/);
        //   if (!pageNumberMatch) throw createError('Invalid url');
        //   return Number(pageNumberMatch[1]);
        // };
        this.createOrganisation = function (name, language, adminDetails) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createOrganisation(name, language, adminDetails)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body];
                }
            });
        }); };
        this.mapAPIOrgConfigToIntegrationOrgConfig = function (body) {
            return {
                organisationId: body.organisation_id,
                isEnabled: body.is_enabled,
                data: body.data,
                created: body.created,
                modified: body.modified
            };
        };
        this.mapAPIAppUserPathwayToIAppUserPathway = function (body) {
            return {
                id: body.id,
                url: body.url,
                originalPathway: body.original_pathway,
                currentStageSlug: body.current_stage_slug,
                disabledRuleIds: body.disabled_rule_ids,
                journeyId: body.journey_id,
                isActive: body.is_active,
                ownerId: body.owner_id,
                externalId: body.external_id
            };
        };
        this.mapAPICareTeamMemberToICareTeamMember = function (body) {
            return {
                id: body.id,
                appUserId: body.app_user_id,
                primaryAppUserId: body.primary_app_user_id,
                staffOrganisationId: body.staff_organisation_id,
                staffUserId: body.staff_user_id,
                name: body.name,
                email: body.email,
                phone: body.phone,
                businessName: body.business_name,
                created: body.created,
                modified: body.modified
            };
        };
        this.mapAPICareTeamRoleToICareTeamRole = function (body) {
            return {
                id: body.id,
                name: body.name,
                description: body.description,
                organisationId: body.organisation_id,
                members: body.members.map(_this.mapAPICareTeamMemberToICareTeamMember),
                createdByType: body.created_by_type,
            };
        };
        this.getIntegrationOrgConfig = function (integrationSlug, organisationId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getIntegrationOrgConfig(integrationSlug, organisationId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrgConfigToIntegrationOrgConfig(body)];
                }
            });
        }); };
        this.createIntegrationOrgConfig = function (integrationSlug, configData, organisationId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createIntegrationOrgConfig(integrationSlug, configData, organisationId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrgConfigToIntegrationOrgConfig(body)];
                }
            });
        }); };
        this.updateIntegrationOrgConfig = function (integrationSlug, isEnabled, configData, organisationId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.updateIntegrationOrgConfig(integrationSlug, isEnabled, configData, organisationId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIOrgConfigToIntegrationOrgConfig(body)];
                }
            });
        }); };
        this.assignPathwayToAppUser = function (appUserId, pathwayId, journeyId, disabledRuleIds, externalId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.assignPathwayToAppUser(appUserId, pathwayId, journeyId, disabledRuleIds, externalId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPIAppUserPathwayToIAppUserPathway(body)];
                }
            });
        }); };
        this.getAppUserCareTeam = function (appUserId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getAppUserCareTeam(appUserId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPICareTeamRoleToICareTeamRole)];
                }
            });
        }); };
        this.getAppUserPathwayCareTeam = function (appUserPathwayId) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.getAppUserPathwayCareTeam(appUserPathwayId)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body.map(this.mapAPICareTeamRoleToICareTeamRole)];
                }
            });
        }); };
        this.createCareTeamRole = function (appUserId, name, description) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createCareTeamRole(appUserId, name, description)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamRoleToICareTeamRole(body)];
                }
            });
        }); };
        this.createCareTeamMember = function (careTeamRoleId, member) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.createCareTeamMember(careTeamRoleId, member)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamMemberToICareTeamMember(body)];
                }
            });
        }); };
        this.editCareTeamMember = function (careTeamMemberId, member) { return __awaiter(_this, void 0, void 0, function () {
            var response, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.editCareTeamMember(careTeamMemberId, member)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, this.mapAPICareTeamMemberToICareTeamMember(body)];
                }
            });
        }); };
        this.deleteCareTeamRole = function (careTeamRoleId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.deleteCareTeamRole(careTeamRoleId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        this.deleteCareTeamMember = function (careTeamMemberId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.deleteCareTeamMember(careTeamMemberId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        if (!client) {
            throw Error('You must provide a pephealth client object.');
        }
    }
    return PEPHealthService;
}());
export default PEPHealthService;
//# sourceMappingURL=service.js.map